<div
    [ngStyle]="{
        'width.px': size,
        'height.px': size,
        'max-height.px': size,
        'background-image': imageUrl(),
        'background-position': 'center',
    }"
    class="photo"
    [class.editable]="editable"
>
    @if (editable) {
        <i class="edit-icon dx-icon-photooutline"></i>
    }
    @if (placeholder) {
        <ng-content></ng-content>
        <span>{{ placeholder }}</span>
    }
</div>
@if (editable) {
    <dx-file-uploader
        [dialogTrigger]="hostRef"
        [visible]="false"
        accept="image/*"
        (onValueChanged)="onUploaderValueChanged($event)"
    ></dx-file-uploader>
}
